import {
  LayoutDashboard, Car, Store, Users, BarChart3, Menu as MenuIcon, Activity,
} from "lucide-react";

export function getNavItems(role) {
  if (role === "team_leader") {
    return {
      sidebar: [
        { to: "/team", label: "Overview", icon: LayoutDashboard, end: true },
        { to: "/leads", label: "All Leads", icon: Car },
        { to: "/dealerships", label: "Dealerships", icon: Store },
        { to: "/team/employees", label: "Team", icon: Users },
        { to: "/reports", label: "Reports", icon: BarChart3 },
        { to: "/more", label: "More", icon: MenuIcon },
      ],
      bottom: [
        { to: "/team", label: "Overview", icon: LayoutDashboard, end: true },
        { to: "/leads", label: "Leads", icon: Car },
        { fab: true, to: "/leads/new", label: "New" },
        { to: "/team/employees", label: "Team", icon: Users },
        { to: "/more", label: "More", icon: MenuIcon },
      ],
    };
  }
  return {
    sidebar: [
      { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
      { to: "/leads", label: "My Leads", icon: Car },
      { to: "/dealerships", label: "Dealerships", icon: Store },
      { to: "/more", label: "Activity & More", icon: Activity },
    ],
    bottom: [
      { to: "/dashboard", label: "Home", icon: LayoutDashboard, end: true },
      { to: "/leads", label: "Leads", icon: Car },
      { fab: true, to: "/leads/new", label: "New Lead" },
      { to: "/dealerships", label: "Dealers", icon: Store },
      { to: "/more", label: "More", icon: MenuIcon },
    ],
  };
}
